class BitmapFontData {
  constructor() {
    this.info = [], this.common = [], this.page = [], this.char = [], this.kerning = [], this.distanceField = [];
  }
}
export {
  BitmapFontData
};
//# sourceMappingURL=BitmapFontData.mjs.map
